
import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  NameFilter, 
  CityFilter, 
  CountryFilter, 
  SortFilter,
  ClearFiltersButton
} from './filters';

interface CollectionsFilterProps {
  nameFilter: string;
  cityFilter: string;
  countryFilter: string;
  sortOption: string;
  onNameFilterChange: (value: string) => void;
  onCityFilterChange: (value: string) => void;
  onCountryFilterChange: (value: string) => void;
  onSortOptionChange: (value: string) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  hasUnappliedChanges: boolean;
}

export const CollectionsFilter = ({
  nameFilter,
  cityFilter,
  countryFilter,
  sortOption,
  onNameFilterChange,
  onCityFilterChange,
  onCountryFilterChange,
  onSortOptionChange,
  onApplyFilters,
  onClearFilters,
  hasUnappliedChanges
}: CollectionsFilterProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onApplyFilters();
  };

  const hasFilters = !!(nameFilter || cityFilter || countryFilter || sortOption !== 'recent');

  return (
    <Card className="p-6 space-y-6 bg-white rounded-lg shadow-sm sticky top-4" onClick={handleClick}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <NameFilter 
          value={nameFilter} 
          onChange={onNameFilterChange} 
        />

        <CityFilter 
          value={cityFilter} 
          onChange={onCityFilterChange} 
        />

        <CountryFilter 
          value={countryFilter} 
          onChange={onCountryFilterChange} 
        />

        <SortFilter 
          value={sortOption} 
          onChange={onSortOptionChange} 
        />

        <div className="flex flex-col gap-2 pt-4 border-t">
          <Button 
            type="submit" 
            className="w-full"
            disabled={!hasUnappliedChanges}
          >
            Apply Filters
          </Button>
          
          {hasFilters && (
            <Button 
              type="button"
              variant="outline" 
              className="w-full"
              onClick={onClearFilters}
            >
              Clear All Filters
            </Button>
          )}
        </div>
      </form>
    </Card>
  );
};
